
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/warnings",
      function () {
        return require("private-next-pages/tools/warnings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/warnings"])
      });
    }
  